var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVentajasdetox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 324.759,
    height: 141.612,
    viewBox: "0 0 324.759 141.612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{isolation:isolate;}.b{fill:#6a841e;}.c{filter:url(#y);}.d{filter:url(#w);}.e{filter:url(#u);}.f{filter:url(#s);}.g{filter:url(#q);}.h{filter:url(#o);}.i{filter:url(#m);}.j{filter:url(#k);}.k{filter:url(#i);}.l{filter:url(#g);}.m{filter:url(#e);}.n{filter:url(#c);}.o{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0.754,
    width: 58.049,
    height: 61.066,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 45.819,
    y: 0.754,
    width: 49.262,
    height: 61.066,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 84.04,
    y: 0.754,
    width: 55.323,
    height: 61.066,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    x: 127.977,
    y: 0.754,
    width: 51.262,
    height: 61.066,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "h"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "h"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    x: 165.037,
    y: 0.754,
    width: 58.339,
    height: 61.066,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "j"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "j"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    x: 200.591,
    y: 0.754,
    width: 40.214,
    height: 72.434,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "l"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "l"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "m",
    x: 229.242,
    y: 0.754,
    width: 58.339,
    height: 61.066,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "n"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "n"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "o",
    x: 273.728,
    y: 0,
    width: 51.031,
    height: 62.37,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "p"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "p"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "q",
    x: 0.147,
    y: 69.324,
    width: 64.872,
    height: 71.496,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "r"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "r"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "s",
    x: 56.414,
    y: 69.36,
    width: 57.744,
    height: 71.46,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "t"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "t"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "u",
    x: 102.098,
    y: 69.36,
    width: 60.156,
    height: 71.46,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "v"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "v"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "w",
    x: 147.24,
    y: 68.568,
    width: 73.08,
    height: 73.044,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "x"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "x"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "y",
    x: 202.789,
    y: 69.324,
    width: 68.477,
    height: 71.496,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "z"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "z"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-521.778 -602.667)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "o",
    transform: "matrix(1, 0, 0, 1, 521.78, 602.67)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M547.192,651.646q-.32-.609-.58-1.233c-.174-.416-.348-.845-.522-1.291l-15.225-38.134a1.029,1.029,0,0,0-.044-.247,1.51,1.51,0,0,1-.043-.391q0-.928,1.189-.929h6.206a1.5,1.5,0,0,1,1.508,1.1q.637,1.826,1.551,4.277t1.943,5.191q1.031,2.74,2.117,5.612t2.117,5.567q1.029,2.7,1.914,5.061t1.494,4.046q.637-1.682,1.508-4.046t1.87-5.061q1-2.7,2.074-5.567t2.088-5.612q1.014-2.741,1.928-5.191t1.581-4.277a1.539,1.539,0,0,1,1.566-1.1h6.09q1.305,0,1.305.957a1.542,1.542,0,0,1-.044.377,1.291,1.291,0,0,0-.043.233l-15.2,38.134q-.233.582-.464,1.175a11.36,11.36,0,0,1-.522,1.146,1.619,1.619,0,0,1-1.073.9,7.589,7.589,0,0,1-1.595.145h-3.335a1.358,1.358,0,0,1-.943-.261A1.832,1.832,0,0,1,547.192,651.646Z",
    transform: "translate(-521.78 -602.67)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "n",
    transform: "matrix(1, 0, 0, 1, 521.78, 602.67)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M576.6,610.814q0-1.392,1.276-1.393h27.956a1.262,1.262,0,0,1,1.073.423,1.709,1.709,0,0,1,.319,1.063v5.122a1.363,1.363,0,0,1-.362.931,1.38,1.38,0,0,1-1.088.407H585.152v8.788h15.892a1.174,1.174,0,0,1,.928.246,1.311,1.311,0,0,1,.348,1.03v5.249a1.559,1.559,0,0,1-.29.928,1.064,1.064,0,0,1-.928.406h-15.95V644.54h21.373a1.289,1.289,0,0,1,1.073.35,1.8,1.8,0,0,1,.261,1.077v5.3q0,1.223-1.276,1.223h-28.71a1.433,1.433,0,0,1-.9-.29,1.1,1.1,0,0,1-.377-.928Z",
    transform: "translate(-521.78 -602.67)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "m",
    transform: "matrix(1, 0, 0, 1, 521.78, 602.67)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M614.818,610.727a1.352,1.352,0,0,1,.334-.929,1.192,1.192,0,0,1,.942-.377h6.67a1.653,1.653,0,0,1,.769.189,1.891,1.891,0,0,1,.652.594q4.961,7.077,9.831,14.051t9.831,14.051V610.524a1.3,1.3,0,0,1,.436-.813,1.275,1.275,0,0,1,.841-.29h5.6a1.517,1.517,0,0,1,1,.349,1.142,1.142,0,0,1,.42.928v40.6q0,1.19-1.363,1.19h-6.293a1.509,1.509,0,0,1-1.188-.784q-5.106-7.394-10.165-14.775T623,622.123V651.21a1.336,1.336,0,0,1-.3.957,1.381,1.381,0,0,1-1.029.32h-5.569a1.257,1.257,0,0,1-.971-.334,1.3,1.3,0,0,1-.3-.913Z",
    transform: "translate(-521.78 -602.67)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "l",
    transform: "matrix(1, 0, 0, 1, 521.78, 602.67)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M658.755,610.7a1.2,1.2,0,0,1,.377-.928,1.349,1.349,0,0,1,.957-.349H690.6a1.523,1.523,0,0,1,.943.32,1.282,1.282,0,0,1,.478.957v5.075a1.539,1.539,0,0,1-.362,1.014,1.3,1.3,0,0,1-1.059.436h-11.02v33.93a1.355,1.355,0,0,1-.362.927,1.271,1.271,0,0,1-1,.407H672.5a1.381,1.381,0,0,1-.944-.377,1.23,1.23,0,0,1-.42-.957v-33.93H660.089a1.321,1.321,0,0,1-.957-.363,1.44,1.44,0,0,1-.377-1.087Z",
    transform: "translate(-521.78 -602.67)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "matrix(1, 0, 0, 1, 521.78, 602.67)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M695.844,651.413a9.432,9.432,0,0,1,.333-1.073c.126-.328.237-.628.334-.9l15.631-38.918a1.727,1.727,0,0,1,.479-.711,1.429,1.429,0,0,1,1.058-.392h4.669a1.263,1.263,0,0,1,1,.349,3.757,3.757,0,0,1,.451.608l.957,2.263,15.311,38.308a1.835,1.835,0,0,0,.044.305,2,2,0,0,1,.043.362q0,.871-1.275.871h-5.714a1.618,1.618,0,0,1-.986-.261,1.91,1.91,0,0,1-.58-.813l-.522-1.334q-.551-1.391-1.1-2.784t-1.073-2.812H707.009q-.753,2.03-1.464,3.813t-1.2,3.117a1.5,1.5,0,0,1-1.508,1.074h-5.8a1.679,1.679,0,0,1-.884-.2.663.663,0,0,1-.334-.608A.9.9,0,0,1,695.844,651.413Zm20.184-30.942q-1.566,4-3.117,8.294t-3.117,8.265h12.353Z",
    transform: "translate(-521.78 -602.67)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "matrix(1, 0, 0, 1, 521.78, 602.67)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M745.143,610.611a1.09,1.09,0,0,1,1.16-1.19h5.859a1.245,1.245,0,0,1,1.421,1.393v39.324a22.1,22.1,0,0,1-.261,3.45,11.572,11.572,0,0,1-1.393,4.09,11.993,11.993,0,0,1-2.682,3.248,12.525,12.525,0,0,1-3.668,2.146,12.059,12.059,0,0,1-4.321.783,13.015,13.015,0,0,1-4.742-.87,10.578,10.578,0,0,1-3.9-2.611c-.116-.1-.242-.213-.377-.347s-.271-.276-.406-.421a2.384,2.384,0,0,1-.334-.449.863.863,0,0,1-.13-.407,1.39,1.39,0,0,1,.13-.536,3.264,3.264,0,0,1,.348-.609c.145-.2.3-.4.464-.594a4.544,4.544,0,0,1,.479-.493l2.668-2.437a1.249,1.249,0,0,1,.42-.246,2.25,2.25,0,0,1,.421-.1,1.258,1.258,0,0,1,.826.333c.261.222.56.465.9.725a6.745,6.745,0,0,0,1.2.725,4.008,4.008,0,0,0,1.74.334,3.559,3.559,0,0,0,1.508-.349,4.938,4.938,0,0,0,1.349-.913,4.565,4.565,0,0,0,.957-1.3,3.431,3.431,0,0,0,.362-1.522Z",
    transform: "translate(-521.78 -602.67)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "matrix(1, 0, 0, 1, 521.78, 602.67)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M760.05,651.413a9.24,9.24,0,0,1,.333-1.073c.125-.328.236-.628.333-.9l15.631-38.918a1.728,1.728,0,0,1,.479-.711,1.429,1.429,0,0,1,1.058-.392h4.669a1.263,1.263,0,0,1,1,.349,3.7,3.7,0,0,1,.451.608l.957,2.263,15.311,38.308a1.841,1.841,0,0,0,.044.305,1.991,1.991,0,0,1,.043.362q0,.871-1.275.871H793.37a1.618,1.618,0,0,1-.986-.261,1.909,1.909,0,0,1-.58-.813l-.522-1.334-1.1-2.784q-.551-1.392-1.073-2.812H771.215q-.755,2.03-1.465,3.813t-1.2,3.117a1.5,1.5,0,0,1-1.509,1.074h-5.8a1.679,1.679,0,0,1-.884-.2.665.665,0,0,1-.334-.608A.865.865,0,0,1,760.05,651.413Zm20.183-30.942q-1.566,4-3.117,8.294T774,637.03h12.353Z",
    transform: "translate(-521.78 -602.67)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "matrix(1, 0, 0, 1, 521.78, 602.67)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M831.041,620.906a1.343,1.343,0,0,1-.7-.189,6.7,6.7,0,0,1-.724-.508l-.059-.028a14.614,14.614,0,0,0-1.421-1.219,14.8,14.8,0,0,0-1.942-1.247,14.155,14.155,0,0,0-2.306-.985,7.963,7.963,0,0,0-2.509-.406,10.332,10.332,0,0,0-2.871.362,6.535,6.535,0,0,0-2.087.986,4.256,4.256,0,0,0-1.277,1.465,3.867,3.867,0,0,0-.434,1.8,2.769,2.769,0,0,0,.652,1.827,6.037,6.037,0,0,0,1.769,1.392,17.3,17.3,0,0,0,2.567,1.116q1.449.508,3.045,1,1.827.551,3.625,1.188a33.582,33.582,0,0,1,3.436,1.436,24.289,24.289,0,0,1,3.06,1.769,11.584,11.584,0,0,1,2.45,2.233,10.171,10.171,0,0,1,1.624,2.813,9.689,9.689,0,0,1,.595,3.494,12.589,12.589,0,0,1-1.277,5.713,13.03,13.03,0,0,1-3.523,4.365,16.172,16.172,0,0,1-5.278,2.784,21.233,21.233,0,0,1-6.51.971,19.192,19.192,0,0,1-4.438-.521,21.54,21.54,0,0,1-4.233-1.48,22.425,22.425,0,0,1-3.843-2.3A19.135,19.135,0,0,1,805.2,645.7v.03l-.059-.116a2.115,2.115,0,0,1-.637-1.334,1.172,1.172,0,0,1,.173-.61,3.541,3.541,0,0,1,.523-.638l.957-.957q.435-.377.928-.84a12.526,12.526,0,0,1,.986-.841q.492-.376.913-.639a1.412,1.412,0,0,1,.682-.261,1.235,1.235,0,0,1,.754.261,5.793,5.793,0,0,1,.58.493l.116.117h-.029a19.237,19.237,0,0,0,2.276,1.827,22.9,22.9,0,0,0,2.6,1.551,15.46,15.46,0,0,0,2.653,1.073,8.733,8.733,0,0,0,2.479.391,10.615,10.615,0,0,0,2.988-.4,7.751,7.751,0,0,0,2.407-1.145,5.51,5.51,0,0,0,1.6-1.785,4.7,4.7,0,0,0,.58-2.319,3.329,3.329,0,0,0-.754-2.189,6.852,6.852,0,0,0-1.973-1.6,15.119,15.119,0,0,0-2.74-1.174q-1.522-.493-3.06-.929a46.17,46.17,0,0,1-6.191-2.319,18.807,18.807,0,0,1-4.423-2.8,10.384,10.384,0,0,1-2.653-3.48,10.275,10.275,0,0,1-.884-4.335,10.774,10.774,0,0,1,4.176-8.715,14.881,14.881,0,0,1,4.813-2.465,20.92,20.92,0,0,1,6.293-.885,18.434,18.434,0,0,1,5.366.827,20.9,20.9,0,0,1,5.045,2.277q.7.435,1.421.985t1.334,1.117a7.687,7.687,0,0,1,1,1.1,1.668,1.668,0,0,1,.392.914,1.647,1.647,0,0,1-.174.71,2.71,2.71,0,0,1-.436.652l-.87.929v-.029q-.435.464-.9.957a11.12,11.12,0,0,1-.929.884q-.463.391-.841.653A1.2,1.2,0,0,1,831.041,620.906Z",
    transform: "translate(-521.78 -602.67)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "matrix(1, 0, 0, 1, 522.78, 602.67)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M578.8,704.811a26.583,26.583,0,0,1-.972,7.254,25.907,25.907,0,0,1-2.773,6.408,26.644,26.644,0,0,1-9.845,9.485,27.949,27.949,0,0,1-6.57,2.611,28.906,28.906,0,0,1-7.308.918H533.581a2.277,2.277,0,0,1-1.152-.288,1.291,1.291,0,0,1-.5-1.224V679.683a1.783,1.783,0,0,1,.414-1.225,1.573,1.573,0,0,1,1.242-.467h17.748a28.172,28.172,0,0,1,7.29.936,27.657,27.657,0,0,1,6.552,2.663,28.107,28.107,0,0,1,5.562,4.141,25.624,25.624,0,0,1,4.3,5.4,27.151,27.151,0,0,1,2.771,6.444A26.152,26.152,0,0,1,578.8,704.811Zm-32.94-13.9V718.6h3.024c.552,0,1.091-.019,1.62-.055s1.056-.077,1.584-.126a14.458,14.458,0,0,0,5.04-1.313,14.012,14.012,0,0,0,4.086-2.88,12.975,12.975,0,0,0,2.736-4.194,13.71,13.71,0,0,0,.99-5.256,13.487,13.487,0,0,0-1.134-5.563,13.68,13.68,0,0,0-7.632-7.271,15.053,15.053,0,0,0-5.562-1.027Z",
    transform: "translate(-522.78 -602.67)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "matrix(1, 0, 0, 1, 522.78, 602.67)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M588.192,679.683a1.716,1.716,0,0,1,.413-1.206,1.5,1.5,0,0,1,1.167-.45h35.716a1.593,1.593,0,0,1,1.225.466,1.782,1.782,0,0,1,.431,1.256v8.9a1.881,1.881,0,0,1-.431,1.167,1.5,1.5,0,0,1-1.261.555H602.124V699.3h18a1.891,1.891,0,0,1,1.134.323,1.241,1.241,0,0,1,.45,1.08v7.777a1.487,1.487,0,0,1-.4.971,1.422,1.422,0,0,1-1.152.468H602.124v9.217h24.192a1.446,1.446,0,0,1,1.62,1.65v9.046a.893.893,0,0,1-.288.647q-.144,1-1.475,1.005h-36.4a1.679,1.679,0,0,1-1.149-.378,1.477,1.477,0,0,1-.431-1.17Z",
    transform: "translate(-522.78 -602.67)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "matrix(1, 0, 0, 1, 522.78, 602.67)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M633.876,679.606a1.462,1.462,0,0,1,.486-1.149,1.752,1.752,0,0,1,1.206-.43H674.3a1.818,1.818,0,0,1,1.153.394,1.615,1.615,0,0,1,.576,1.185v8.937a2.018,2.018,0,0,1-.45,1.239,1.513,1.513,0,0,1-1.279.592h-12.42v39.419a1.712,1.712,0,0,1-.466,1.171,1.559,1.559,0,0,1-1.221.523H649.639A1.693,1.693,0,0,1,648.49,731a1.562,1.562,0,0,1-.538-1.207V690.374H635.568a1.673,1.673,0,0,1-1.206-.466,1.806,1.806,0,0,1-.486-1.365Z",
    transform: "translate(-522.78 -602.67)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(1, 0, 0, 1, 522.78, 602.67)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M679.018,704.811a27.359,27.359,0,0,1,3.747-13.914,27.921,27.921,0,0,1,4.3-5.6,26.9,26.9,0,0,1,5.565-4.3,28.279,28.279,0,0,1,6.575-2.771,27.568,27.568,0,0,1,14.643,0A28.215,28.215,0,0,1,720.446,681a27.331,27.331,0,0,1,9.889,9.9,28.572,28.572,0,0,1,2.773,6.588,27.6,27.6,0,0,1,0,14.652,27.889,27.889,0,0,1-2.773,6.552,27.1,27.1,0,0,1-4.3,5.544,28.147,28.147,0,0,1-5.584,4.3,27.555,27.555,0,0,1-27.811,0,27.894,27.894,0,0,1-9.87-9.845,26.881,26.881,0,0,1-2.774-6.552A27.29,27.29,0,0,1,679.018,704.811Zm13.933-.036a15.285,15.285,0,0,0,1.006,5.58,13.77,13.77,0,0,0,2.823,4.517,13.158,13.158,0,0,0,4.3,3.025,14.2,14.2,0,0,0,10.947,0,13.1,13.1,0,0,0,4.315-3.025,13.768,13.768,0,0,0,2.822-4.517,15.916,15.916,0,0,0,0-11.143,13.945,13.945,0,0,0-2.822-4.554,13.418,13.418,0,0,0-19.558,0,13.948,13.948,0,0,0-2.823,4.554A15.333,15.333,0,0,0,692.951,704.775Z",
    transform: "translate(-522.78 -602.67)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, 522.78, 602.67)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M734.639,730.551q.288-.54.594-1.1a13.124,13.124,0,0,1,.7-1.133l16.2-24.193q-4.14-6.227-8.19-12.311T735.756,679.5a3.435,3.435,0,0,1-.343-.54,1.618,1.618,0,0,1-.161-.54.351.351,0,0,1,.413-.269,1.4,1.4,0,0,0,.7-.162H748.9a2.311,2.311,0,0,1,2.088,1.368l8.82,13.248,8.928-13.248a2.311,2.311,0,0,1,2.088-1.368h11.988c.264,0,.51,0,.739.018a1.734,1.734,0,0,1,.593.126.349.349,0,0,1,.252.323,1.562,1.562,0,0,1-.4.937l-16.56,24.731,16.884,25.2a6.48,6.48,0,0,1,.559.918,1.328,1.328,0,0,1,.161.7q0,.54-.648.54H771.5a1.876,1.876,0,0,1-1.117-.361,2.427,2.427,0,0,1-.792-.971L759.8,715.647l-9.684,14.508a2.444,2.444,0,0,1-.792.971,1.877,1.877,0,0,1-1.115.361H735.287a.809.809,0,0,1-.5-.163.528.528,0,0,1-.216-.45A.713.713,0,0,1,734.639,730.551Z",
    transform: "translate(-522.78 -602.67)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentajasdetox);
export default __webpack_public_path__ + "static/media/ventajasdetox.db5e28be6c5ccfb2df5db9aa8db527c7.svg";
export { ForwardRef as ReactComponent };